module.exports = __webpack_public_path__ + "img/CZATS.f9c326a4.png";